import { importChunk } from "./appVersion";

/**
 * The one place that names the PDF chunk, for all 17 download call sites.
 *
 * react-pdf and the Inter TTFs must never enter the main bundle, so every one of
 * those sites reaches the renderer through a dynamic import. Routing them all
 * through importChunk means a deploy that moved the chunk's hashed filename
 * heals itself instead of failing as "Gagal mengunduh laporan", which is what an
 * admin whose tab predates the deploy used to get with no way to recover.
 *
 * Deliberately NOT inside src/pdf/: a module in that folder could later be
 * static-imported by accident and drag the whole chunk into the main bundle.
 */
export const loadReportPdf = () => importChunk(() => import("pdf/generatePdf"));
